<div [ngClass]="labelClass" class="au-cmms-status-label">
	{{ labelName | translate }}
</div>
